<div
    class="modal fade"
    [id]="modalId" 
    tabindex="-1" 
    role="dialog" 
    aria-labelledby="modelTitleId" 
    aria-hidden="true"
    >
    <div 
        class="modal-dialog modal-xl modal-dialog-centered" 
        role="document"
        >
        <div 
            class="modal-content rounded" 
            [ngClass]="{'bg-dark': isDarkmode}"
            >
            <div class="modal-header"></div>
            <!-- MODAL BODY -->
            <div class="modal-body no-padding">
                <div 
                    class=""
                    *ngIf="image"
                    >
                    <img 
                        class="image-preview"
                        [src]="image.url"
                        >
                </div>
            </div>
            <div class="modal-footer">
                <button 
                    type="button" 
                    class="btn btn-danger"
                    (click)="removeImage()"
                    >{{"buttons.button_delete_image" | translate}}
                </button>
                <button 
                    type="button" 
                    class="btn btn-secondary"
                    (click)="closeModal()"
                    >{{"buttons.button_close" | translate}}
                </button>
              </div>
        </div>
    </div>
</div>